import React, { Component, Fragment } from 'react';
import { Row, Col, Select, Button, InputNumber, Divider, Form, Checkbox } from 'antd';
import { Indicators } from './indicators';
const Option = Select.Option;

export class SignalForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            thresholdEnabled: false
        };
    }

    componentDidUpdate(prevProps) {
        let form = { ...this.props.signal };
        const indicatorOutputs = this.getIndicatorOutputs();

        const values = [
            ...indicatorOutputs,
            ...[
                {
                    title: `Bearish Match`,
                    value: `bearish_pattern_match`
                },
                {
                    title: `Bullish Match`,
                    value: `bullish_pattern_match`
                }
            ]
        ];

        const matchA = values.filter(a => a.value === form.a);
        if (matchA.length) {
            form[`a_label`] = matchA[0].title;
        }

        const matchB = values.filter(a => a.value === form.b);
        if (matchB.length) {
            form[`b_label`] = matchB[0].title;
        }

        if (this.props.signal.a_label !== form.a_label) {
            // this.setState({form});
            this.props.onChange(form);
        }
    }

    onChange(key, indicatorValues, value) {
        let form = { ...this.props.signal };
        form[key] = value.target ? value.target.value : value;

        if (key === 'required') {
            form[key] = value.target.checked;
        }
        if (key === 'a' || key === 'b') {
            const values = [
                ...indicatorValues,
                ...[
                    {
                        title: `Bearish Match`,
                        value: `bearish_pattern_match`
                    },
                    {
                        title: `Bullish Match`,
                        value: `bullish_pattern_match`
                    }
                ]
            ];
            const match = values.filter(a => a.value === value);
            if (match.length) {
                form[`${key}_label`] = match[0].title;
            }
        }

        this.props.onChange(form);
    }

    getTimeFrames(indicators) {
        const set = new Set(indicators.map(i => i.period || '30m'));
        return [...set];
    }

    render() {
        const indicatorOutputs = this.getIndicatorOutputs();
        const form = this.props.signal;

        const [leftIndicatorId] = form.a.split(':');
        let leftIndicator = null;
        if (leftIndicatorId) {
            leftIndicator = this.props.indicators.find(
                a => a.id === parseFloat(leftIndicatorId, 10)
            );
        }

        return (
            <Fragment>
                <Row gutter={24} style={{ position: 'relative' }}>
                    <Col md={8} xxl={7}>
                        <Form.Item label={'Source A'}>
                            <Select
                                style={{ width: '100%' }}
                                placeholder={'Select source'}
                                value={form.a}
                                onChange={this.onChange.bind(this, 'a', indicatorOutputs)}
                            >
                                {indicatorOutputs
                                    .filter(output => output.value !== 'threshold')
                                    .map(output => {
                                        return (
                                            <Option key={output.value} value={output.value}>
                                                {output.title}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={3} xxl={3}>
                        <Form.Item label={'Clause'}>
                            <Select
                                style={{ width: '100%' }}
                                placeholder={'Select comparison clause'}
                                value={form.clause}
                                onChange={this.onChange.bind(this, 'clause', null)}
                            >
                                <Option value={'eq'}>Equal</Option>
                                <Option value={'gt'}>Greater than</Option>
                                <Option value={'gte'}>Greater than equal</Option>
                                <Option value={'lt'}>Less than</Option>
                                <Option value={'lte'}>Less than equal</Option>
                                <Option value={'cross_above'}>Cross Above</Option>
                                <Option value={'cross_below'}>Cross Below</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={8} xxl={7}>
                        <Form.Item label={'Source B'}>
                            <Select
                                style={{ width: '100%' }}
                                placeholder={'Select source to compare'}
                                value={form.b}
                                onChange={this.onChange.bind(this, 'b', indicatorOutputs)}
                            >
                                {leftIndicator && leftIndicator.indicator_id.indexOf('CDL') === 0
                                    ? [
                                          {
                                              title: `Bearish Match`,
                                              value: `bearish_pattern_match`
                                          },
                                          {
                                              title: `Bullish Match`,
                                              value: `bullish_pattern_match`
                                          }
                                      ].map(output => {
                                          return (
                                              <Option key={output.value} value={output.value}>
                                                  {output.title}
                                              </Option>
                                          );
                                      })
                                    : indicatorOutputs.map(output => {
                                          return (
                                              <Option key={output.value} value={output.value}>
                                                  {output.title}
                                              </Option>
                                          );
                                      })}
                            </Select>
                        </Form.Item>
                    </Col>
                    {form.b === 'threshold' ? (
                        <Col md={4} xxl={2}>
                            <Form.Item label={'Threshold'}>
                                <InputNumber
                                    placeholder="Enter Value"
                                    value={form.threshold || 0}
                                    onChange={this.onChange.bind(this, 'threshold', null)}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                    ) : null}

                    <Col md={3} xxl={3}>
                        <Form.Item label={'Keep Signal for'}>
                            <InputNumber
                                style={{ width: '100%' }}
                                value={form.keep_signal || 0}
                                onChange={this.onChange.bind(this, 'keep_signal', null)}
                            />
                        </Form.Item>
                    </Col>

                    <Col md={2} xxl={2}>
                        <Form.Item label={'Required'}>
                            <Checkbox
                                checked={form.required}
                                onChange={this.onChange.bind(this, 'required', null)}
                            />
                        </Form.Item>
                    </Col>

                    <Button
                        style={{ position: 'absolute', right: 6, top: 41 }}
                        shape="circle"
                        type="danger"
                        icon="close-circle"
                        onClick={this.props.onRemove.bind(this)}
                    />
                </Row>
                <Divider style={{ margin: 0 }} />
            </Fragment>
        );
    }

    getIndicatorOutputs() {
        let indicatorOutputs = [
            {
                title: 'Threshold',
                value: 'threshold'
            }
        ];

        const timeframes = this.getTimeFrames(this.props.indicators);
        timeframes.forEach(tf => {
            indicatorOutputs.push({
                title: `${tf} - Open`,
                value: `${tf}:open`
            });
            indicatorOutputs.push({
                title: `${tf} - High`,
                value: `${tf}:high`
            });
            indicatorOutputs.push({
                title: `${tf} - Low`,
                value: `${tf}:low`
            });
            indicatorOutputs.push({
                title: `${tf} - Close`,
                value: `${tf}:close`
            });
            indicatorOutputs.push({
                title: `${tf} - Volume`,
                value: `${tf}:volume`
            });
        });

        this.props.indicators.forEach(ind => {
            const schema = Indicators[ind.indicator_id];
            if (!schema) return;
            schema.outputs.forEach(output => {
                indicatorOutputs.push({
                    title: `#${ind.id} ${schema.name} ${ind.period} - ${output.label}`,
                    value: `${ind.id}:${output.name}`
                });
            });
        });
        return indicatorOutputs;
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Shared/IndicatorManager/SignalForm.js